import React from "react";
import ReactDOM from "react-dom";

import { ShopifyImportToast } from "./sections/ShopifyImportToast";
import {
  dismissShopifyImportSession,
  useShopifyImportSession,
} from "./shopifyImportSession";

/** Renders the WebBridge-style import snackbar above all shopify-nudge routes. */
export const ShopifyImportSessionHost: React.FC = () => {
  const session = useShopifyImportSession();

  if (!session.visible) return null;

  return ReactDOM.createPortal(
    <ShopifyImportToast
      visible={session.visible}
      phase={session.phase}
      completed={session.completed}
      total={session.total}
      autoPublish={session.autoPublish}
      importProductIds={session.importProductIds}
      onDismiss={dismissShopifyImportSession}
    />,
    document.body
  );
};
